import React from 'react'
import RenderInView from '@pcln/render-in-view'
import styled from 'styled-components'

const getMarginBottom = ({ isSponsoredAd }) =>
  /* istanbul ignore next */
  isSponsoredAd ? '0px' : '10px'

const getMarginTop = ({ afterSponsoredAd }) => (afterSponsoredAd ? '10px' : '0px')

const InViewWrapper = styled.li`
  display: block;
  /* istanbul ignore next */
  margin-bottom: ${(props) => getMarginBottom(props)};
  margin-top: ${(props) => getMarginTop(props)};

  ${(props) => {
    if (props.isInlineAds) {
      return `@media (min-width: 840px) {
        display: none;
      }`
    }

    if (props.mobileOnly) {
      return `
        ${props.theme.flyQueries.tablet} {
          display: none;
        }
      `
    }
    return `display: block`
  }}
`

export function WrapComponentsRenderInView(listingsNodes, alwaysRenderFirstN) {
  return listingsNodes.map(
    (elem, idx) =>
      elem &&
      !elem.hide && (
        <InViewWrapper
          mobileOnly={elem.mobileOnly}
          isInlineAds={elem.inlineAds}
          isSponsoredAd={elem.isSponsoredAd}
          afterSponsoredAd={elem.afterSponsoredAd}
        >
          <RenderInView
            rootMargin={'200px 0px 700px 0px'}
            alwaysRender={isNaN(alwaysRenderFirstN) ? false : idx <= alwaysRenderFirstN}
          >
            {elem.component}
          </RenderInView>
        </InViewWrapper>
      )
  )
}
